import React from 'react'
import { withRouter } from "react-router-dom";
import CustomerList from './components/customerList'
 function Customer() {
    return (
       <CustomerList></CustomerList>
    )
}
export default withRouter(Customer);
